import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import LoginForm from './components/LoginForm';
import SignupForm from './components/SignupForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import GainAccessForm from './components/GainAccessForm';

function App() {
  const [config, setConfig] = useState(null);
  const [view, setView] = useState('login');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [targetUrl, setTargetUrl] = useState(null);
  const [storedEmail, setStoredEmail] = useState('');
  const iframeRef = useRef();

  // Fetch config + check cookie
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const basicAuth = btoa(`${process.env.REACT_APP_CONFIG_USER}:${process.env.REACT_APP_CONFIG_PASS}`);
        const res = await fetch(process.env.REACT_APP_PRELOGIN_LAMBDA, {
          headers: {
            Authorization: `Basic ${basicAuth}`,
            'Content-Type': 'application/json',
          },
        });

        if (!res.ok) throw new Error(`Config fetch failed: ${res.status}`);

        const json = await res.json();
        setConfig(json);

        const cookie = document.cookie
          .split('; ')
          .find((row) => row.startsWith('kingdom_auth='));

        if (cookie) {
          try {
            const cookieData = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
            console.log('👑 kingdom_auth cookieData:', cookieData);
            if (cookieData?.target) {
              setIsLoggedIn(true);
              setTargetUrl(cookieData.target);
            }
          } catch (err) {
            console.error('❌ Failed to parse login cookie:', err);
          }
        }
      } catch (err) {
        console.error('❌ Config error:', err);
      }
    };

    fetchConfig();
  }, []);

  // Post message to Retool iframe after login
  useEffect(() => {
    if (isLoggedIn && targetUrl && iframeRef.current) {
      const cookie = document.cookie
        .split('; ')
        .find((c) => c.startsWith('kingdom_auth='));
      if (cookie) {
        try {
          const payload = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
          const { name, email, role } = payload;

          iframeRef.current.contentWindow.postMessage({ name, email, role }, '*');
        } catch (err) {
          console.error('Failed to postMessage login data:', err);
        }
      }
    }
  }, [isLoggedIn, targetUrl]);

  // After login/signup
  const handleSuccess = (data) => {
    if (data && data.token && data.target) {
      const payload = {
        token: data.token,
        target: data.target,
        email: data.email,
        name: data.name,
        role: data.role
      };
      document.cookie = `kingdom_auth=${encodeURIComponent(JSON.stringify(payload))}; path=/; secure; SameSite=Lax`;
      setIsLoggedIn(true);
      setTargetUrl(data.target);
    }
  };

  if (!config) return <div style={{ padding: 50 }}>Loading config...</div>;

  if (isLoggedIn && targetUrl) {
    return (
      <iframe
        ref={iframeRef}
        title="Dashboard"
        src={targetUrl}
        style={{ width: '100%', height: '100vh', border: 'none' }}
      />
    );
  }

  return view === 'login' ? (
    <LoginForm
      appName={config.app_name}
      logoUrl={config.login_screen_logo}
      onSuccess={handleSuccess}
      switchToSignup={() => setView('signup')}
      switchToForgot={() => setView('forgot')}
    />
  ) : view === 'signup' ? (
    <SignupForm
      appName={config.app_name}
      logoUrl={config.login_screen_logo}
      onSuccess={handleSuccess}
      switchToLogin={() => setView('login')}
      setStoredEmail={setStoredEmail}
      switchToGainAccess={() => setView('gain')}
    />
  ) : view === 'forgot' ? (
    <ForgotPasswordForm
      appName={config.app_name}
      switchToLogin={() => setView('login')}
    />
  ) : (
    <GainAccessForm
      appName={config.app_name}
      email={storedEmail}
      switchToLogin={() => setView('login')}
    />
  );
}

export default App;
